<svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26">
  <g fill="none" fill-rule="evenodd">
    <rect width="32" height="25.6" fill="#C6B0E9" rx="1.6"/>
    <path fill="#713AC9" d="M1.6 0h28.8A1.6 1.6 0 0 1 32 1.6v1.6H0V1.6A1.6 1.6 0 0 1 1.6 0z"/>
    <rect width="3.2" height="3.2" x="6.4" y="6.4" fill="#713AC9" rx=".4"/>
    <rect width="3.2" height="3.2" x="14.4" y="17.6" fill="#713AC9" rx=".4"/>
    <rect width="3.2" height="3.2" x="22.4" y="12.8" fill="#713AC9" rx=".4"/>
  </g>
</svg>
